<template>
  <el-dialog :visible.sync="showModal" title="关联试卷" append-to-body>
    <el-form :model="searchForm" label-width="100px" ref="form" inline size="small">
      <el-form-item label="试卷名称" prop="title">
        <el-input v-model="searchForm.title" placeholder="请输入关键字" />
      </el-form-item>
      <!-- <el-form-item label="所属分类" prop="classificationId">
        <el-select v-model="searchForm.classificationId" style="width:100%">
          <el-option :label="item.name" :value="item.id" v-for="(item,index) in typeData" :key="index"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item style="margin-left: 50px">
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset('form')" style="margin-left: 8px">重置</el-button>
      </el-form-item>
    </el-form>
    <br />
    <el-table border v-loading="loading" :data="tableData" style="width: 100%" ref="table">
      <el-table-column label="选择" type="selection" prop="id" width="60" :selectable="checkSelectable" align="center" />
      <el-table-column label="试卷名称" prop="title" minWidth="170" align="center" />
      <el-table-column label="创建时间" prop="insertDate" minWidth="170" align="center" />
    </el-table>
    <br />
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="pageSizes" layout="total, sizes, prev, pager, next" :total="total" />
    <div slot="footer">
      <el-button @click="showModal = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import tableMoudel from "@/libs/mixins/table"
import { typeMoudel } from "../../mixins"
import { courseTypeList } from "../../dict"
import { examPaperPage, examPaperTopicAdds } from "../../api"

export default {
  mixins: [typeMoudel, tableMoudel],
  data () {
    return {
      courseTypeList,
      showModal: false,
      searchForm: {
        title: "",
        classificationId: null,
      },
      examTopicId: null,
    }
  },
  methods: {
    checkSelectable: (row, index) => row.isInExamTopic == 1 ? false : true,
    init (examTopicId,projectId) {
      this.examTopicId = examTopicId
      // this.projectId = projectId
      this.showModal = true
      this.getData()
    },
    async getData () {
      const params = {
        ...this.pageInfo,
        ...this.searchForm
      }
      params.examTopicId = this.examTopicId
      // params.projectId = this.projectId
      const res = await examPaperPage(params)
      const { records, total } = res.data
      this.total = Number(total)
      this.tableData = records
    },
    async submit () {
      const selectData = this.$refs.table.selection.map(item => item.id)
      if (selectData.length == 0) return this.$message.warning('请选择要关联的数据!')
      const params = selectData.map(item => {
        return {
          examTopicId: this.examTopicId,
          examPaperId: item
        }
      })
      const res = await examPaperTopicAdds(params)
      if (res.code !== 0) return this.$message.error(res.message)
      this.$emit('update', true)
      this.showModal = false
    }
  }
}
</script>

<style>
</style>
